import React, { Component, Fragment } from "react";
import List from "./List";
import Footer from "../../utilities/Footer";
import AppContext from "../../../contexts/AppContext";
import NoData from "../../utilities/NoData";
import LoadingData from "../../utilities/LoadingData";

import {
    records,
    record,
    search,
    filter
} from "../../../services/employerJobs";
import Header from "../account/Header";
import AccountNav from "../account/AccountNav";

class jobs extends Component {
    state = {
        items: [],
        meta: {},
        query: "",
        filter: false,
        search: false,
        loading: true,
        tableCount: "hide",
        filterItem: "all",
        togglePadding: 'mt-3'
    };

    toggleTableCount = () => {
        this.setState({
            tableCount: this.state.tableCount === "hide" ? "show" : "hide"
        });
    };
    record = id => {
        return record(id);
    };
    onQueryChange = field => {
        this.setState({ query: field.target.value });
    };
    search = query => {
        this.setState({ loading: true });
        search(query).then(response => {
            this.setState({
                items: response.data,
                meta: response.meta,
                search: true,
                query: query,
                loading: false
            });
        });
    };

    filter = item => {
        this.setState({ loading: true });
        filter(item).then(response => {
            this.setState({
                items: response.data,
                meta: response.meta,
                filter: true,
                loading: false,
                filterItem: item
            });
        });
    };
    clear = () => {
        this.setState({ loading: true });
        records(1)
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    search: false,
                    filter: false,
                    loading: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    };

    componentDidMount() {
        if(this.context.state.user.email_verified === 'false') {
            this.setState({togglePadding: 'mt-15'});
          }
        records(1)
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    loading: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }

    changePage = page => {
        if (this.state.search === true) {
            search(this.state.query, page).then(response => {
                this.setState({ items: response.data, meta: response.meta });
            });
        } else {
            records(page).then(response => {
                this.setState({ items: response.data, meta: response.meta });
            });
        }
    };
    submitSearch = e => {
        e.preventDefault();
        if (this.state.query.length >= 1) {
            this.search(this.state.query);
        } else {
            this.clear();
        }
    };

    render() {
        const user = this.state.meta;
        return (
            <Fragment>
               <Header />
               {/* <section className="dashboard-nav">
		                <div className="container employer-container">
		            	    <div className="head">
		            		    <h1 className="text-white">Welcome back,  { user.first_name }!</h1>
		            			<h2>Let's find you some great writers.</h2>
		            		</div>
							<AccountNav></AccountNav>
		            	</div>
		       </section> */}
                <div className={`main-content pb-20 pt-20 ${this.state.togglePadding}`}>
                    <div className="employer-container container">
                        <div className="row justify-content-center">
                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <div className="header">
                                    <div className="header-body">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h1 className="header-title">
                                                    Jobs
                                                </h1>
                                                <h6 className="header-pretitle">
                                                    Overview all available Jobs
                                                </h6>
                                            </div>
                                        </div>
                                        <div className="row align-items-center">
                                            <div className="col"></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card">
                                    <div className="card-header">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <form
                                                    onSubmit={this.submitSearch}
                                                    className="row align-items-center"
                                                >
                                                    <div className="col-auto pr-0">
                                                        <span className="fe fe-search text-muted"></span>
                                                    </div>
                                                    <div className="col">
                                                        <input
                                                            onChange={this.onQueryChange.bind(
                                                                this
                                                            )}
                                                            value={
                                                                this.state.query
                                                            }
                                                            type="search"
                                                            className="form-control form-control-flush search"
                                                            placeholder="Search"
                                                        ></input>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        {this.state.loading === true ? (
                                            <LoadingData></LoadingData>
                                        ) : this.state.items.length >= 1 ? (
                                            <table className="table table-sm table-nowrap card-table">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <div className="custom-control custom-checkbox table-checkbox">
                                                                #
                                                            </div>
                                                        </th>
                                                        <th>Title</th>
                                                        <th>Applicants</th>
                                                        <th>Date</th>
                                                        <th>Status</th>
                                                        <th className="Options">
                                                            Options
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="list">
                                                    {this.state.items.map(
                                                        (item, index) => {
                                                            return (
                                                                <List
                                                                    getItem={
                                                                        this
                                                                            .record
                                                                    }
                                                                    item={item}
                                                                    index={
                                                                        index
                                                                    }
                                                                    key={index}
                                                                ></List>
                                                            );
                                                        }
                                                    )}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <NoData></NoData>
                                        )}
                                    </div>
                                    <div>
                                        <Footer
                                            changePage={this.changePage}
                                            totalPages={this.state.meta.pages}
                                            curentPage={this.state.meta.page}
                                        ></Footer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
jobs.contextType = AppContext;
export default jobs;



// WEBPACK FOOTER //
// ./src/components/employer/jobs/Jobs.js